import moment from 'moment/min/moment-with-locales';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney, roundUpToNearestBig } from '@/helpers/utils';
import { DATE_FORMAT_YYYY } from '@/helpers/common';
import { setModals } from '@/store/actions/commonActions';
import { MODAL_TYPES } from '../../../ModalProvider';
import { RoundButton } from '@/components/UI/RoundButton';
import { Image } from '@/components/Image';
import EmptyImage from '../../../../assets/images/startup_mock.svg';
import { MyLink } from '@/components/MyLink';
import s from './index.module.scss';

// TODO replace with new BrandDetailModal, this card has many dependencies especially in Loan Page
export const StartupCard = ({
  startup,
  href,
  hideFR,
  onMoreDetails,
  roundUp = true,
  className,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isReviewing = startup.fundraising_goal === 0;

  const onCompanyClick = () => {
    typeof startup.id === 'number' &&
      dispatch(
        setModals({
          type: MODAL_TYPES.company_info,
          companyID: startup.id,
        }),
      );
  };

  const content = (
    <>
      {isReviewing && (
        <div className={s.review}>
          <span>{t('startup_card_v3.reviewing')}</span>
        </div>
      )}

      <div className={s.image}>
        <Image
          image={startup.promo_image || EmptyImage}
          preset="brandCard"
          alt={startup.name}
        />
      </div>

      <div className={s.inner}>
        <div className={s.top}>
          <div className={s.header}>
            <div className={s.header_left}>
              <h4 className={classnames('f-26-32 f-500', s.title)}>
                {startup.name}
              </h4>
              <p className={s.desc}>{startup.promo_theme}</p>
            </div>
            {isReviewing ||
              (!hideFR && (
                <div className={classnames(s.header_right, 'f-18-24 f-500')}>
                  <span>
                    {prettyFloatMoney(
                      roundUp
                        ? roundUpToNearestBig(
                            startup.fundraising_goal ||
                              startup.max_allowed_goal,
                          )
                        : startup.fundraising_goal || startup.max_allowed_goal,
                    )}
                  </span>
                </div>
              ))}
          </div>

          <div className={classnames('f-16 f-400', s.description)}>
            {startup.promo_description}
          </div>
        </div>
        <div
          className={classnames(s.bottom, isReviewing && s.bottom_reviewing)}
        >
          <div className={s.info}>
            <div className={classnames('f-16 f-400', s.country)}>
              {startup.country_code && (
                <img
                  src={`https://flagcdn.com/${startup.country_code?.toLowerCase()}.svg`}
                  alt="flag"
                />
              )}
              {startup.country}
            </div>
            {startup.foundation_date && (
              <div className={classnames('f-16 f-400', s.foundation)}>
                {t('startup_card_v3.started_in_date', {
                  date: moment(startup.foundation_date).format(
                    DATE_FORMAT_YYYY,
                  ),
                })}
              </div>
            )}
          </div>

          <div className={s.buttons}>
            <RoundButton
              label={t('startup_card_v3.more_details')}
              className={classnames(
                s.button,
                typeof startup.id !== 'number' && 'hidden',
              )}
              onClick={() => {
                onMoreDetails && onMoreDetails(startup);
                !href && onCompanyClick();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );

  return href ? (
    <MyLink href={href} className={classnames(s.wrapper, className)}>
      {content}
    </MyLink>
  ) : (
    <div className={classnames(s.wrapper, className)} onClick={onCompanyClick}>
      {content}
    </div>
  );
};
